<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 20 21"
    fill="none"
    style="enable-background:new 0 0 20 21;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_certeiro">
      <path
        id="Ellipse 35"
        d="M12.6667 4.88788C11.5683 4.32045 10.3216 4 9 4C4.58172 4 1 7.58172 1 12C1 16.4183 4.58172 20 9 20C13.4183 20 17 16.4183 17 12C17 10.3643 16.5091 8.84335 15.6667 7.57627"
        stroke-linecap="round"
      />
      <path
        id="Ellipse 39"
        d="M15 12C15 15.3137 12.3137 18 9 18C5.68629 18 3 15.3137 3 12C3 8.68629 5.68629 6 9 6C9.99117 6 10.9262 6.24033 11.75 6.66591"
        stroke-linecap="round"
      />
      <circle id="Ellipse 38" cx="9" cy="12" r="2" stroke-linecap="round" />
      <path id="Vector 1" d="M8.7998 12.2L18.3998 1.80005" stroke-linecap="round" />
      <path
        id="Vector 2"
        d="M17.2998 1C17.2998 0.723858 17.0759 0.5 16.7998 0.5C16.5237 0.5 16.2998 0.723858 16.2998 1H17.2998ZM16.7998 3.4H16.2998V3.9H16.7998V3.4ZM19.1998 3.9C19.4759 3.9 19.6998 3.67614 19.6998 3.4C19.6998 3.12386 19.4759 2.9 19.1998 2.9V3.9ZM16.2998 1V3.4H17.2998V1H16.2998ZM16.7998 3.9H19.1998V2.9H16.7998V3.9Z"
        fill="#9AABB8"
      />
      <path
        id="Vector 3"
        d="M15.5 3C15.5 2.72386 15.2761 2.5 15 2.5C14.7239 2.5 14.5 2.72386 14.5 3H15.5ZM15 5.4H14.5V5.9H15V5.4ZM17.4 5.9C17.6761 5.9 17.9 5.67614 17.9 5.4C17.9 5.12386 17.6761 4.9 17.4 4.9V5.9ZM14.5 3V5.4H15.5V3H14.5ZM15 5.9H17.4V4.9H15V5.9Z"
        fill="#9AABB8"
      />
    </g>
  </svg>
</template>
<style scoped>
.icon-prognosis {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-prognosis"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>